export default __webpack_public_path__ + "static/media/img6.18975cb6.png";